import React, {Component} from 'react';
import {Col, Container, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Link, withRouter} from "react-router-dom";

//import TopbarNavDashboards from "../topbar_with_navigation/tobar_nav/TopbarNavDashboards";
import TopbarNavDashboards from "../topbar_with_navigation/tobar_nav/TopbarNavOneDashboard";
//import TopbarNavEvents from "../topbar_with_navigation/tobar_nav/TopbarNavEvents";
import TopbarNavEvents from "../topbar_with_navigation/tobar_nav/TopbarNavOneEvents";
//import TopbarNavHealth from "../topbar_with_navigation/tobar_nav/TopbarNavHealth";
import TopbarNavHealth from "../topbar_with_navigation/tobar_nav/TopbarNavOneHealth";
import TopbarAIService from "../topbar_with_navigation/tobar_nav/TopbarAIService";
import TopbarSettings from "../topbar_with_navigation/TopbarSettings";
import TopbarLanguage from "../topbar_with_navigation/TopbarLanguage";
import TopbarProfile from "../topbar_with_navigation/TopbarProfile";

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'dashboard'
        };
    }

    componentWillMount() {
        const { location} =this.props;
        console.log("location: ", location);
        let activeTab = 'dashboard';
        if (location && location.pathname =="/asset_events"){
            activeTab ='event'
        } else if (location && location.pathname =="/asset_health"){
            activeTab ='health'
        }
        this.setState({activeTab});
    }

    handleActiveTab = (activeTab) => {
        this.setState({activeTab});
        console.log('click ', activeTab);
    }

    render() {
        const { activeTab } = this.state;
        console.log('activeTab ', activeTab);
        return (
            <section id="header">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center col-xs-12 col-sm-12">
                            <nav className="navbar navbar-default navbar-static-top" role="navigation">
                                <div className="navbar-header">
                                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse"
                                            data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"/>
                                        <span className="icon-bar"/>
                                        <span className="icon-bar"/>
                                    </button>
                                    <div id="logo" className="navbar-brand">
                                        <Link to="/dashboard_assets">
                                            <img src="img/logo.png" alt=""/>
                                        </Link>
                                    </div>
                                </div>
                                <div id="navbar" className="navbar-collapse collapse show">
                                    <ul className="nav navbar-nav">
                                        <li className={ activeTab === 'dashboard'?'navbar_dropdown active':'navbar_dropdown'} onClick={()=>{this.handleActiveTab('dashboard')}}>
                                            <TopbarNavDashboards  />
                                        </li>
                                        <li className={ activeTab === 'event'?'navbar_dropdown active':'navbar_dropdown'} onClick={()=>{this.handleActiveTab('event')}} >
                                            <TopbarNavEvents />
                                        </li>
                                        <li className={ activeTab === 'health'?'navbar_dropdown active':'navbar_dropdown'} onClick={()=>this.handleActiveTab('health')}>
                                            <TopbarNavHealth />
                                        </li>
                                    </ul>
                                    <ul className="nav navbar-nav navbar-right pull-right">
                                        <li className="navbar_dropdown">
                                            <TopbarAIService />
                                        </li>
                                        <li className="navbar_dropdown">
                                            <TopbarSettings />
                                        </li>
                                        <li className="navbar_dropdown">
                                            <TopbarProfile />
                                            {/*<a href="#">
                                                <div className="dropdown">
                                                    <button id="dLabel" type="button" data-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                        <i className="lnr lnr-user" aria-hidden="true"/>
                                                        <span className="caret"/>
                                                    </button>
                                                    <ul className="dropdown-menu" aria-labelledby="dLabel">
                                                        ...
                                                    </ul>
                                                </div>
                                            </a>*/}
                                        </li>
                                        <li className="navbar_dropdown">
                                            <TopbarLanguage />
                                        </li>
                                    </ul>
                                </div>
                                {/*/.nav-collapse */}
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const HeaderWithRoute = withRouter(props => <Header {...props}/>);

export default withTranslation('common')(HeaderWithRoute);
